module.exports = __webpack_public_path__ + "static/media/is.ae44c07e.svg";